/**
 * editorImages.service.ts — an image placed inside rich content (an email
 * template body, an e-form block), uploaded through POST /surveys/upload-image
 * (the account's S3 image folder; files over 4 MB go the presigned way). The
 * corporate dashboard wrote these straight to S3 with its own credentials.
 */
import { uploadFile } from '@/services/uploads.service';

/** Largest image accepted, as corp's editor and the API (10 MB). */
export const EDITOR_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

/** Uploads the image and returns its public URL. */
export async function uploadEditorImage(file: File): Promise<string> {
  if (!file.type.startsWith('image/')) throw new Error('Please select an image file.');
  if (file.size > EDITOR_IMAGE_MAX_BYTES) throw new Error('Image must be smaller than 10MB.');
  const r = await uploadFile('/surveys/upload-image', file, undefined, { fileFieldName: 'image' });
  const url = r?.data?.data?.url as string | undefined;
  if (!url) throw new Error('The upload finished but no image URL came back.');
  return url;
}
